import { render } from "./KamranGalleries.vue?vue&type=template&id=fecad7c6&scoped=true"
import script from "./KamranGalleries.vue?vue&type=script&lang=js"
export * from "./KamranGalleries.vue?vue&type=script&lang=js"

import "./KamranGalleries.vue?vue&type=style&index=0&id=fecad7c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fecad7c6"]])

export default __exports__